export enum PromoStatus {
  'Facture' = 'facture',
  'Confirme' = 'confirme',
  'Simulation' = 'simulation',
  'Propose' = 'propose',
  'Budget' = 'budget'
}
